import React, { useState, useEffect, useRef, useContext } from "react";
import "../../css/CRUDModal.css";
import DeleteConfirmationModal from "./DeleteConfirmationVendor";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import { BankNameContext } from "../../context/BankNameContext";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";

const VendorModal = ({
  show,
  handleClose,
  editData,
  action,
  fetchVendorData,
}) => {
  const { bankNames } = useContext(BankNameContext);
  const loggedInUserName = sessionStorage.getItem("username");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [smsTypeOpen, setSmsTypeOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    username: loggedInUserName,
    vendorName: "",
    vendorAddress: "",
    vendorCode: "",
    smsType: "",
    spocName: "",
    spocContactNo: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
    rate: "",
    rcsRate: "",
  });
  const [errors, setErrors] = useState({
    vendorName: "",
    vendorAddress: "",
    vendorCode: "",
    smsType: "",
    spocName: "",
    spocContactNo: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
    rate: "",
    rcsRate: "",
  });

  useEffect(() => {
    if (action === "add") {
      setFormData({
        username: loggedInUserName,
        vendorName: "",
        vendorAddress: "",
        vendorCode: "",
        smsType: "",
        spocName: "",
        spocContactNo: "",
        bankName: "",
        accountNo: "",
        ifscCode: "",
        rate: "",
        rcsRate: "",
      });
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete"
    ) {
      setFormData({
        ...editData,
        username: loggedInUserName,
        // smsType: editData.smsType || ''
      });
    }
  }, [action, editData]);

  const smsTypeRef = useRef(null);
  const toggleSMSTypeDropdown = () => setSmsTypeOpen(!smsTypeOpen);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (smsTypeRef.current && !smsTypeRef.current.contains(event.target)) {
      setSmsTypeOpen(false);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (id === "vendorName" || id === "ifscCode" || id === "spocName") {
      updatedValue = value.toUpperCase();
    } else if (id === "spocContactNo" || id === "accountNo") {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    setFormData({ ...formData, [id]: updatedValue });
  };

  // // Simple validation function
  const validate = (field = null) => {
    const newErrors = {};
    // Name validation (between 2 and 50 characters)

    if (!field || field === "vendorName") {
      formData.vendorName = formData.vendorName.trim().replace(/\s{2,}/g, " ");
      if (!formData.vendorName) {
        newErrors.vendorName = "Vendor Name is required";
      } else if (
        !/^[A-Za-z0-9][A-Za-z0-9\s.&-]*[A-Za-z0-9.&-]$/.test(
          formData.vendorName
        )
      ) {
        newErrors.vendorName =
          "Vendor name can include letters, numbers, spaces, dots, hyphens, and ampersands only";
      } else if (formData.vendorName.length < 2) {
        newErrors.vendorName = "Vendor name must be at least 2 characters long";
      } else if (formData.vendorName.length > 100) {
        newErrors.vendorName =
          "Vendor name must be no more than 100 characters long";
      } else if (/([a-zA-Z0-9])\1{7}/.test(formData.vendorName.toLowerCase())) {
        newErrors.vendorName =
          "Vendor name cannot have 8 or more repeated identical characters";
      }
    }

    // Vendor Code validation (alphanumeric and 10 characters)
    if (!field || field == "vendorCode") {
      if (!formData.vendorCode) {
        newErrors.vendorCode = "Vendor code is required";
      } else if (!/^[a-zA-Z1-9][a-zA-Z0-9]{3,9}$/.test(formData.vendorCode)) {
        newErrors.vendorCode =
          "Vendor code must be alphanumeric, 4–10 characters long, and must not start with 0";
      }
    }

    if (!field || field == "smsType") {
      if (!formData.smsType) {
        newErrors.smsType = "Select SMS type";
      }
    }

    // Bank Name validation
    if (!formData.bankName) {
      newErrors.bankName = "Bank Name is required";
    }

    // Address validation
    if (!field || field === "vendorAddress") {
      formData.vendorAddress = formData.vendorAddress.trim();
      if (!formData.vendorAddress) {
        newErrors.vendorAddress = "Address is required";
      } else if (!/^[A-Za-z0-9\s,.\/#-]+$/.test(formData.vendorAddress)) {
        newErrors.vendorAddress =
          "Address can only include letters, numbers, spaces, commas, dots, hyphens, slashes, and hashes";
      } else if (!/[A-Za-z]/.test(formData.vendorAddress)) {
        newErrors.vendorAddress = "Address must include at least one letter";
      } else if (formData.vendorAddress.length < 5) {
        newErrors.vendorAddress = "Address must be at least 5 characters long";
      } else if (formData.vendorAddress.length > 150) {
        newErrors.vendorAddress =
          "Address must be no more than 150 characters long";
      }
    }

    if (!field || field == "spocName") {
      formData.spocName = formData.spocName.trim().replace(/\s{2,}/g, " ");
      if (!formData.spocName) {
        newErrors.spocName = "SPOC Name is required";
      } else if (
        !/^[A-Za-z0-9][A-Za-z0-9\s-]{0,48}[A-Za-z0-9]$/.test(formData.spocName)
      ) {
        newErrors.spocName =
          "SPOC Name must be valid, alphanumeric with spaces or hyphens, and between 2 and 50 characters";
      } else if (formData.vendorName.length < 2) {
        newErrors.vendorName = "Vendor name must be at least 2 characters long";
      } else if (formData.vendorName.length > 100) {
        newErrors.vendorName =
          "Vendor name must be no more than 100 characters long";
      } else if (/([a-zA-Z0-9])\1{7}/.test(formData.vendorName.toLowerCase())) {
        newErrors.vendorName =
          "Vendor name cannot have 8 or more repeated identical characters";
      }
    }

    if (!field || field == "spocContactNo") {
      if (!formData.spocContactNo) {
        newErrors.spocContactNo = "SPOC Mobile no. is required";
      } else if (!/^[6789]\d{9}$/.test(formData.spocContactNo)) {
        newErrors.spocContactNo =
          "Mobile number must be exactly 10 digits and start with 6, 7, 8, or 9";
      } else if (/^(\d)\1{9}$/.test(formData.spocContactNo)) {
        newErrors.spocContactNo =
          "Mobile number cannot be the same digit repeated";
      }
    }

    if (!field || field === "bankName") {
      if (!formData.bankName) {
        newErrors.bankName = "Bank Name is required";
      }
    }

    if (!field || field === "accountNo") {
      const isIncreasingSeq = "0123456789".includes(formData.accountNo);
      const isDecreasingSeq = "9876543210".includes(formData.accountNo);

      // Account Number validation (between digits 5 to 30)
      if (!formData.accountNo) {
        newErrors.accountNo = "Account Number is required";
      } else if (!/^\d{9,18}$/.test(formData.accountNo)) {
        newErrors.accountNo = "Account Number must be 9 to 18 digits";
      } else if (/^(\d)\1+$/.test(formData.accountNo)) {
        newErrors.accountNo =
          "Account Number cannot be the same digit repeated";
      } else if (
        isIncreasingSeq ||
        isDecreasingSeq ||
        formData.accountNo === "0123456789" ||
        formData.accountNo === "9876543210" ||
        formData.accountNo === "0987654321"
      ) {
        newErrors.accountNo = "Account number must not be a sequential pattern";
      }
    }

    // IFSC Code validation (must be 11 characters)
    if (!field || field == "ifscCode") {
      if (!formData.ifscCode) {
        newErrors.ifscCode = "IFSC code is required";
      } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.ifscCode)) {
        newErrors.ifscCode =
          "IFSC code must be 4 uppercase letters, followed by 0, then 6 letters or digits";
      }
    }

    // Rate validation (between values 0.01 to 0.99)
    // if (!formData.rate) {
    //   newErrors.rate = "SMS Rate is required";
    // } else if (
    //   !/^(0\.[0-9]{1,2}|0\.0[1-9]|0\.[1-9][0-9])$/.test(formData.rate)
    // ) {
    //   newErrors.rate = "Rate value must be between 0.01 to 0.99";
    // }

    // if (!formData?.rcsRate) {
    //   newErrors.rcsRate = "RCS Rate is required";
    // } else if (
    //   !/^(0\.[0-9]{1,2}|0\.0[1-9]|0\.[1-9][0-9])$/.test(formData?.rcsRate)
    // ) {
    //   newErrors.rcsRate = "RCS Rate value must be between 0.01 to 0.99";
    // }

    // if (!field || field == "rate" || field == "rcsRate") {
    //   if (!formData?.rate && !formData?.rcsRate) {
    //     newErrors.rate = "At least one of SMS Rate or RCS Rate is required";
    //     newErrors.rcsRate = "At least one of SMS Rate or RCS Rate is required";
    //   } else {
    //     if (
    //       formData?.rate &&
    //       !/^(0\.[0-9]{1,2}|0\.0[1-9]|0\.[1-9][0-9])$/.test(formData?.rate)
    //     ) {
    //       newErrors.rate = "SMS Rate value must be between 0.01 to 0.99";
    //     }
    //     if (
    //       formData?.rcsRate &&
    //       !/^(0\.[0-9]{1,2}|0\.0[1-9]|0\.[1-9][0-9])$/.test(formData?.rcsRate)
    //     ) {
    //       newErrors.rcsRate = "RCS Rate value must be between 0.01 to 0.99";
    //     }
    //   }
    // }

    // Rate validation (At least one required, not both empty)
    if (!formData.rate && !formData.rcsRate) {
      newErrors.rate = "At least one of SMS Rate or RCS Rate is required";
      newErrors.rcsRate = "At least one of SMS Rate or RCS Rate is required";
    } else {
      // ✅ SMS Rate validation
      if (formData.rate) {
        if (
          !/^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/.test(
            formData.rate.toString().trim()
          )
        ) {
          newErrors.rate = "SMS Rate value must be between 1.00 to 99.00";
        }
      }

      // ✅ RCS Rate validation
      if (formData.rcsRate) {
        if (
          !/^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/.test(
            formData.rcsRate.toString().trim()
          )
        ) {
          newErrors.rcsRate = "RCS Rate value must be between 1.00 to 99.00";
        }
      }
    }

    const rateRegex = /^0\.\d{1,2}$/;

    const rateStr = formData?.rate || "";
    const rcsRateStr = formData?.rcsRate || "";

    const rateValue = parseFloat(rateStr || "0");
    const rcsRateValue = parseFloat(rcsRateStr || "0");

    const isRateValid = rateRegex.test(rateStr);
    const isRcsRateValid = rateRegex.test(rcsRateStr);

    // Ensure at least one is non-zero
    // if (rateValue === 0 && rcsRateValue === 0) {
    //   newErrors.rate = "Either SMS Rate or RCS Rate is required (not both 0)";
    //   newErrors.rcsRate =
    //     "Either SMS Rate or RCS Rate is required (not both 0)";
    // } else {
    //   if (rateStr && !isRateValid) {
    //     newErrors.rate =
    //       "SMS Rate must be between 0.00 and 0.99 with 2 decimals";
    //   }
    //   if (rcsRateStr && !isRcsRateValid) {
    //     newErrors.rcsRate =
    //       "RCS Rate must be between 0.00 and 0.99 with 2 decimals";
    //   }
    // }
    // Regex for values 1 – 99, with optional .00 / .5 / .99
    const numberRegex = /^(?:[1-9][0-9]?)(?:\.[0-9]{1,2})?$/;

    if (
      (rateValue === 0 || isNaN(rateValue)) &&
      (rcsRateValue === 0 || isNaN(rcsRateValue))
    ) {
      newErrors.rate = "Either SMS Rate or RCS Rate is required (not both 0)";
      newErrors.rcsRate =
        "Either SMS Rate or RCS Rate is required (not both 0)";
    } else {
      if (rateStr && !numberRegex.test(rateStr)) {
        newErrors.rate = "SMS Rate must be between 1.00 and 99.00";
      }
      if (rcsRateStr && !numberRegex.test(rcsRateStr)) {
        newErrors.rcsRate = "RCS Rate must be between 1.00 and 99.00";
      }
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id } = e.target;
    const fieldErrors = validate(id);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: fieldErrors[id] || "", // Update only the error for the blurred field
    }));
  };

  const handleAddVendor = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitted(true);
      let apiUrl = "";
      let successMessage = "";

      if (action === "add") {
        apiUrl = apiList.CREATE_VENDOR_DATA; // Add
        successMessage = "Vendor added successfully";
      } else if (action === "modify") {
        apiUrl = apiList.MODIFY_VENDOR_DATA; // Modify
        successMessage = "Vendor details modified successfully";
      }

      const sanitizedFormData = {
        ...formData,
        rate: formData.rate === "" ? "0.00" : formData.rate,
        rcsRate: formData.rcsRate === "" ? "0.00" : formData.rcsRate,
      };
      axiosPostApi(apiUrl, sanitizedFormData)
        .then((response) => {
          if (response.status === 200 && response.data.status === true) {
            toast.success(successMessage, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            handleClose();
            fetchVendorData(1);
            return;
          }

          if (response.data.respCode === "01") {
            const errorFields = response.data.data.errorFields;
            const errorMessages = Object.values(errorFields).join("\n");
            CustomAlert({
              title: "Data Submission Error",
              text: errorMessages || "Please check the details and try again.",
              icon: "error",
              confirmButtonText: "Retry",
            });
            return;
          }
          CustomAlert({
            title:
              action === "add"
                ? "Failed to Add Vendor"
                : "Failed to Modify Vendor",
            text:
              response.data.message ||
              "There was an issue processing the request. Please try again.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        })
        .catch((error) => {
          console.error("Error processing customer request:", error);
          CustomAlert({
            title: "Error",
            text:
              action === "add"
                ? "An error occurred while adding the customer. Please try again later."
                : "An error occurred while modifying the vendor. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div
        className={`modal-lg modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title main-title">
                {action.charAt(0).toUpperCase() + action.slice(1)} Vendor
                Details
              </h5>
            </div>
            <form onSubmit={(e) => handleAddVendor(e)}>
              <div className="scoped-modal modal-body">
                <form>
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="vendorName">
                          Vendor Name<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="vendorName"
                          value={formData?.vendorName || ""}
                          disabled={isViewMode || isDeleteMode}
                          placeholder="Enter Vendor Name"
                          maxLength={150}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode) && errors.vendorName ? (
                          <span className="error">{errors.vendorName}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="vendorCode">
                          Vendor Code<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Vendor Code"
                          id="vendorCode"
                          value={formData?.vendorCode || ""}
                          disabled={isViewMode || isDeleteMode}
                          maxLength={10}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[a-zA-Z0-9]{0,10}$/.test(value)) {
                              handleInputChange(e);
                            }
                          }}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode) && errors.vendorCode ? (
                          <span className="error">{errors.vendorCode}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="smsType">
                        SMS Type<span style={{ color: "red" }}>*</span>
                      </label>
                      <div
                        className="form-group position-relative"
                        ref={smsTypeRef}
                      >
                        <select
                          className="form-control select-dropdown"
                          id="smsType"
                          placeholder="SMS Type"
                          value={formData?.smsType || ""}
                          disabled={isViewMode || isDeleteMode}
                          onClick={toggleSMSTypeDropdown}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        >
                          <option value="" disabled>
                            SMS Type
                          </option>
                          <option value="Transactional">Transactional</option>
                          <option value="Promotional">Promotional</option>
                        </select>
                        <span className="position-absolute select-icon">
                          {smsTypeOpen ? <ChevronUp /> : <ChevronDownIcon />}
                        </span>
                      </div>
                      {!(isViewMode || isDeleteMode) && errors.smsType ? (
                        <span className="error">{errors.smsType}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="vendorAddress">
                        Vendor Address<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="vendorAddress"
                        value={formData?.vendorAddress || ""}
                        disabled={isViewMode || isDeleteMode}
                        placeholder="Vendor Address"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {!(isViewMode || isDeleteMode) && errors.vendorAddress ? (
                        <span className="error">{errors.vendorAddress}</span>
                      ) : null}
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="spocName">
                          Vendor SPOC Name
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="spocName"
                          value={formData?.spocName || ""}
                          disabled={isViewMode || isDeleteMode}
                          placeholder="Vendor SPOC Name"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode) && errors.spocName ? (
                          <span className="error">{errors.spocName}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="spocContactNo">
                        Vendor SPOC Contact No
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="spocContactNo"
                        value={formData?.spocContactNo || ""}
                        disabled={isViewMode || isDeleteMode}
                        placeholder="Vendor SPOC Contact No"
                        maxLength={10}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!(isViewMode || isDeleteMode) && errors.spocContactNo ? (
                        <span className="error">{errors.spocContactNo}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="bankName">
                        Bank Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        id="bankName"
                        className="form-select"
                        value={formData?.bankName || ""}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        style={{ appearance: "listbox" }}
                      >
                        <option value="">Select Bank</option>
                        {bankNames?.map((bank) => (
                          <option key={bank.bankId} value={bank.bankName}>
                            {bank.bankName}
                          </option>
                        ))}
                      </select>
                      {!(isViewMode || isDeleteMode) && errors.bankName ? (
                        <span className="error">{errors.bankName}</span>
                      ) : null}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="accountNo">
                        Account No<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="accountNo"
                        value={formData?.accountNo || ""}
                        disabled={isViewMode || isDeleteMode}
                        placeholder="Account No"
                        maxLength={30}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,30}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!(isViewMode || isDeleteMode) && errors.accountNo ? (
                        <span className="error">{errors.accountNo}</span>
                      ) : null}
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="ifscCode">
                          IFSC Code<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="ifscCode"
                          value={formData?.ifscCode || ""}
                          disabled={isViewMode || isDeleteMode}
                          placeholder="IFSC Code"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode) && errors.ifscCode ? (
                          <span className="error">{errors.ifscCode}</span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="rate">
                        SMS Rate<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="rate"
                        style={{ textAlign: "right" }}
                        value={formData?.rate || ""}
                        disabled={isViewMode || isDeleteMode}
                        placeholder="SMS Rate"
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode) && errors.rate ? (
                        <span className="error">{errors.rate}</span>
                      ) : null}
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="rcsRate">
                          RCS Rate<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="RCS Rate"
                          id="rcsRate"
                          style={{ textAlign: "right" }}
                          value={formData?.rcsRate}
                          disabled={isViewMode || isDeleteMode}
                          onChange={handleInputChange}
                        />
                        {!(isViewMode || isDeleteMode) && errors.rcsRate ? (
                          <span className="error">{errors.rcsRate}</span>
                        ) : null}
                      </div>
                    </div>
                  </div> */}

                  <div className="row mb-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="rate">
                          SMS Rate{" "}
                          <span style={{ color: "black" }}>(in paisa)</span>
                          {!formData?.rcsRate ? (
                            <span style={{ color: "red" }}>*</span>
                          ) : null}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="SMS Rate"
                          id="rate"
                          value={formData?.rate}
                          disabled={isViewMode || isDeleteMode}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode) && errors.rate ? (
                          <span className="error">{errors.rate}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="rcsRate">
                          RCS Rate{" "}
                          <span style={{ color: "black" }}>(in paisa)</span>
                          {!formData?.rate ? (
                            <span style={{ color: "red" }}>*</span>
                          ) : null}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="RCS Rate"
                          id="rcsRate"
                          value={formData?.rcsRate}
                          disabled={isViewMode || isDeleteMode}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode) && errors.rcsRate ? (
                          <span className="error">{errors.rcsRate}</span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="scoped-modal modal-footer">
                <button
                  type="button"
                  className="btn btn-back"
                  onClick={handleBack}
                >
                  Back
                </button>
                {!isViewMode && !isDeleteMode && (
                  <button type="submit" className="btn btn-submit">
                    {isEditMode ? "Update" : "Submit"}
                  </button>
                )}
                {isDeleteMode && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={openModal}
                  >
                    Delete
                  </button>
                )}
                <DeleteConfirmationModal
                  isOpen={isModalOpen}
                  onClose={closeModal}
                  handleClose={handleClose}
                  editData={editData}
                  fetchVendorData={fetchVendorData}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
      {isModalOpen && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default VendorModal;
